import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {
  private mobileRegex = /Mobi|Android|iPhone|iPad|iPod/i;

  public isMobileDevice(): boolean {
    return this.mobileRegex.test(navigator.userAgent);
  }
}